// extracted by mini-css-extract-plugin
export default {"wrap":"ntiSWK8i","section":"KCjtc5RZ","sectionTitle":"nVGIz8i_","empty":"aIBqypkL"};